// Dashboard routes
export default [{
  path: 'dashboard',
  name: 'Dashboard',
  meta: {
    title: 'navbar.dashboard',
  },
  component: () => import(/* webpackChunkName: "dashboard" */ '../views/dashboard/Dashboard.vue'),
}];
